import type {DigitalEditionItemData, Item, ListItemData, Page} from '../../types/types.ts';
import type {LayoutParser} from '../lib/layout-parser.ts';
import type {Store} from '../lib/store.ts';
import type {Article} from '../models/article.ts';
import {ContentAdapter} from './content-adapter.ts';

export class DefaultContentAdapter extends ContentAdapter {
	readonly locale = 'no-NO';
	readonly timezone = 'Europe/Oslo';

	getSectionForPrintItem(printPage: Page, item: Item, parser: LayoutParser) {
		const printPageSection = printPage.properties?.section;

		const value = parser.getSection() || printPageSection || item.data.section || item.data.category || '';
		return value.replace(/-inngang/i, '').replace(/^nyhet$/i, 'nyheter');
	}

	getStoryForPrintItem(_printPage: Page, item: Item, parser: LayoutParser): string {
		return parser.getStory() || parser.getFirstWordLeadin() || item.data.story || item.data.topic || '';
	}

	ensurePublishedAt(_item: ListItemData): Promise<void> {
		throw new Error('Method not implemented.');
	}

	loadItem(
		_article: Article,
		_groupBy: string | null,
		_sortOrder: number | undefined,
		_store: Store
	): Promise<Article | null> {
		throw new Error('Method not implemented.');
	}

	loadSingleItem(_articleId: string, _sourceId: string | undefined, _store: Store): Promise<Article> {
		throw new Error('Method not implemented.');
	}

	formatListItems(
		_items: ListItemData[],
		_groupBy: string | null,
		_date: string | null,
		_store: Store,
		_sourceId?: string,
		_timezone?: string
	): Article[] {
		throw new Error('Method not implemented.');
	}

	createEditionBrief(
		_data: DigitalEditionItemData,
		_store: Store,
		_articleIdsInEditiond: string[],
		_editionTitle: string
	): Article {
		throw new Error('Method not implemented.');
	}

	getListQueryParams(_publishDate: string) {
		return {};
	}
}
